<div class="p-6">
  <div class="flex justify-between items-center mb-6">
    <h1 class="text-2xl font-bold">組織（テナント）管理</h1>
    <button matButton="tonal" color="primary" (click)="openForm()">
      <mat-icon>add</mat-icon>
      組織追加
    </button>
  </div>

  @if (organizationService.isLoading()) {
    <div class="flex justify-center items-center py-12">
      <mat-spinner diameter="40"></mat-spinner>
    </div>
  } @else if (organizationService.error()) {
    <div class="bg-red-50 text-red-600 p-4 rounded-lg">
      {{ organizationService.error() }}
    </div>
  } @else if (organizationService.organizations().length === 0) {
    <div class="bg-primary-container p-12 text-center rounded-lg shadow-sm">
      <mat-icon class="text-4xl text-gray-400 mb-2">business</mat-icon>
      <p class="text-gray-500">組織が登録されていません</p>
    </div>
  } @else {
    <div class="bg-primary-container rounded-lg shadow-sm overflow-hidden">
      <table mat-table [dataSource]="organizationService.organizations()" class="w-full">
        
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef> 組織名 </th>
          <td mat-cell *matCellDef="let org"> {{org.name}} </td>
        </ng-container>

        <ng-container matColumnDef="features">
          <th mat-header-cell *matHeaderCellDef> 有効機能 </th>
          <td mat-cell *matCellDef="let org">
            <div class="flex flex-wrap gap-1 py-2">
              @for (feature of org.enabledFeatures; track feature) {
                <span class="px-2 py-1 bg-gray-100 text-gray-600 text-xs rounded-full">
                  {{ formatFeatureName(feature) }}
                </span>
              }
              @if (!org.enabledFeatures || org.enabledFeatures.length === 0) {
                <span class="text-gray-400 text-sm">なし</span>
              }
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef class="w-16"></th>
          <td mat-cell *matCellDef="let org">
            <button matIconButton aria-label="組織操作" [matMenuTriggerFor]="menu">
              <mat-icon>more_vert</mat-icon>
            </button>
            <mat-menu #menu="matMenu" xPosition="before">
              <button mat-menu-item (click)="openForm(org)">
                <mat-icon>edit</mat-icon>
                <span>編集</span>
              </button>
              <button mat-menu-item (click)="deleteOrganization(org.id, org.name)">
                <mat-icon class="text-red-600!">delete</mat-icon>
                <span class="text-red-600!">削除</span>
              </button>
            </mat-menu>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="hover:bg-gray-50"></tr>
      </table>
    </div>
  }
</div>
